import { render, staticRenderFns } from "./AdminSchools.vue?vue&type=template&id=0b1fe686&scoped=true&"
import script from "./AdminSchools.vue?vue&type=script&lang=js&"
export * from "./AdminSchools.vue?vue&type=script&lang=js&"
import style0 from "./AdminSchools.vue?vue&type=style&index=0&id=0b1fe686&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1fe686",
  null
  
)

export default component.exports